import { LinearProgress, Stack } from "@mui/material";
import { DataGrid, DataGridProps, GridSlots } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

/*
 * Notes:
 * 1. Using Flex parent container to avoid use autoHeight https://mui.com/x/react-data-grid/layout/#flex-parent-container
 */

type SuperDataGridProps = DataGridProps & {
  noRowsOverlayText?: string;
  autoCacheRowCount?: boolean;
  for: string;
};

export const SuperDataGrid = ({
  noRowsOverlayText = "No Data Found",
  autoCacheRowCount = true,
  ...props
}: SuperDataGridProps) => {
  /*
   * rowCount must be set if not paginationModel will reset,
   * because rowCount almost don't change we can cache it
   */
  const { rowCount, ...rest } = props;
  const [rowCountCache, setRowCountCache] = useState(0);

  useEffect(() => {
    if (props.rowCount) {
      setRowCountCache(props.rowCount);
    }
  }, [props]);

  return (
    <DataGrid
      className={`SuperDataGrid__${props.for}`}
      slots={{
        loadingOverlay: LinearProgress as GridSlots["loadingOverlay"],
        noRowsOverlay: () => (
          <Stack alignItems="center" justifyContent="center" marginTop="30px">
            {noRowsOverlayText}
          </Stack>
        ),
      }}
      rowHeight={40}
      columnHeaderHeight={40}
      rowCount={autoCacheRowCount ? rowCountCache : rowCount}
      {...rest}
    />
  );
};
